export default __webpack_public_path__ + "static/park-pedregal-amenidades-10-fut-7-8336a0590ea20f3bacf9c06d4680f4f5.jpg";